import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";
import { TextNode } from "lexical";
import { BroadcastNode } from "../nodes/broadcast-node";
import { ButtonListNodeMui } from "../nodes/button-list-mui";
import { ChannelNodeMui } from "../nodes/channel/channel-node-mui";
import { CustomEmojiNode } from "../nodes/custom-emoji/custom-emoji-node";
import { DataTableCellNode } from "../nodes/data-table-cell-node";
import { DataTableNode } from "../nodes/data-table-node";
import { DesignHuddleNodeMui } from "../nodes/design-huddle-mui";
import { DividerNodeMui } from "../nodes/divider-mui";
import { DynamicContentNode } from "../nodes/dynamic-content/dynamic-content-node";
import { DynamicContentToolbarNodeMui } from "../nodes/dynamic-content/dynamic-content-toolbar-node-mui";
import { EmojiNode } from "../nodes/emoji-node";
import { ImageNodeMui } from "../nodes/image-node-mui";
import { MergeTagV2Node } from "../nodes/merge-tag-node-v2";
import { PaperColorNode } from "../nodes/paper-color-node";
import { PollNodeMui } from "../nodes/poll/poll-node-mui";
import { StylableButtonNodeMui } from "../nodes/stylable-button-mui";
import { SurveyLinkNode } from "../nodes/survey-link-node";
import { VideoNodeMui } from "../nodes/video-node-mui";

// Remember to update EDITOR_NODES_HEADLESS
export const EDITOR_NODES = {
  sms: [
    EmojiNode,
    SurveyLinkNode,
    AutoLinkNode,
    MergeTagV2Node,
    DynamicContentToolbarNodeMui,
    DynamicContentNode,
  ],
  chat: [
    ListNode,
    ListItemNode,
    LinkNode,
    AutoLinkNode,
    TextNode,
    EmojiNode,
    DividerNodeMui,
    ButtonListNodeMui,
    ImageNodeMui,
    DesignHuddleNodeMui,
    MergeTagV2Node,
    DynamicContentToolbarNodeMui,
    DynamicContentNode,
    PollNodeMui,
    CustomEmojiNode,
    VideoNodeMui,
    BroadcastNode,
    ChannelNodeMui,
  ],
  email: [
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    TableNode,
    TableCellNode,
    DataTableCellNode,
    DataTableNode,
    TableRowNode,
    LinkNode,
    AutoLinkNode,
    TextNode,
    EmojiNode,
    DividerNodeMui,
    ImageNodeMui,
    DesignHuddleNodeMui,
    StylableButtonNodeMui,
    PaperColorNode,
    MergeTagV2Node,
    DynamicContentToolbarNodeMui,
    DynamicContentNode,
    PollNodeMui,
    VideoNodeMui,
  ],
};
